/**
 * Asynchronously loads the component for PreviewComponent
 */

import { lazyLoad } from 'utils/loadable';

export const PreviewComponent = lazyLoad(
  () => import('./index'),
  module => module.PreviewComponent,
);
